import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { GLOVE_SPECS } from "@/lib/data";
import { Reveal, SectionHead } from "./Reveal";

const WEIGHTS = Object.keys(GLOVE_SPECS);

const ROWS = [
  ["Einsatz", "use"],
  ["Polsterung", "padding"],
  ["Speed", "speed"],
];

export default function SpecExplorer() {
  const [active, setActive] = useState("16oz");
  const spec = GLOVE_SPECS[active];

  return (
    <section data-testid="spec-section" className="py-16 sm:py-24">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead
          eyebrow="// Wähle deine Waffe"
          title={
            <>
              Der Spec <span className="text-stroke-gold">Explorer</span>
            </>
          }
          index="MZ—04"
          sub="Jedes Gewicht hat eine Aufgabe. Finde deine."
        />

        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <Reveal className="lg:col-span-4 flex flex-col gap-3">
            {WEIGHTS.map((w) => (
              <button
                key={w}
                data-testid={`spec-weight-${w}-btn`}
                onClick={() => setActive(w)}
                className={`flex items-center justify-between border px-6 py-5 sm:py-6 transition-all duration-300 ${
                  active === w
                    ? "border-gold bg-gold/10"
                    : "border-white/10 hover:border-white/30 bg-transparent"
                }`}
              >
                <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/50">
                  {GLOVE_SPECS[w].use}
                </span>
                <span
                  className={`font-display font-black text-2xl sm:text-3xl tracking-tight transition-colors duration-300 ${
                    active === w ? "text-gold" : "text-white/70"
                  }`}
                >
                  {w.toUpperCase()}
                </span>
              </button>
            ))}
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-8">
            <div className="relative h-full border border-white/10 bg-panel p-8 sm:p-12 overflow-hidden">
              <AnimatePresence mode="wait">
                <motion.div
                  key={active}
                  data-testid="spec-detail-panel"
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -24 }}
                  transition={{ duration: 0.35 }}
                >
                  <div className="flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-8">
                    <span className="font-display font-black leading-none tracking-tighter text-7xl sm:text-9xl text-gold">
                      {spec.oz}
                      <span className="text-3xl sm:text-5xl text-white/40 ml-2">OZ</span>
                    </span>
                    <p className="text-slate-300 max-w-sm text-sm sm:text-base leading-relaxed pb-2">{spec.note}</p>
                  </div>

                  <div className="mt-10 border-t border-white/10">
                    {ROWS.map(([label, key]) => (
                      <div
                        key={key}
                        className="flex items-center justify-between py-4 border-b border-white/10"
                        data-testid={`spec-row-${key}`}
                      >
                        <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/40">{label}</span>
                        <span className="font-display font-bold uppercase tracking-tight text-lg sm:text-xl">
                          {spec[key]}
                        </span>
                      </div>
                    ))}
                  </div>
                </motion.div>
              </AnimatePresence>
              <span className="pointer-events-none absolute -bottom-10 -right-4 font-display font-black text-[9rem] sm:text-[13rem] leading-none text-stroke opacity-20 select-none">
                MAZARO
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
